var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.834 9.167h1.667v1.666H5.834V9.167Zm0 3.333h1.667v1.667H5.834V12.5Zm3.333-3.333h1.667v1.666H9.167V9.167Zm0 3.333h1.667v1.667H9.167V12.5Zm3.334-3.333h1.666v1.666h-1.666V9.167Zm0 3.333h1.666v1.667h-1.666V12.5Z",
  fill: "#00BAC6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.167 18.333h11.666c.92 0 1.667-.747 1.667-1.666V5c0-.92-.747-1.667-1.667-1.667h-1.666V1.667H12.5v1.666h-5V1.667H5.833v1.666H4.167C3.247 3.333 2.5 4.081 2.5 5v11.667c0 .919.748 1.666 1.667 1.666ZM15.833 6.667l.001 10H4.167v-10h11.666Z",
  fill: "#00BAC6"
})));
export { SvgCalendar as ReactComponent };
export default __webpack_public_path__ + "f3585347bd6e1fc6bc432c6efaf3e644.svg";